import contentMapAdapter from 'apps/templates/models/ContentMap/adapter'
import {
  InstalledTemplate,
  AdaptedInstalledTemplate,
  TemplateFieldAdapted,
} from 'shared/api/common/schemas/templates/installedTemplate'
import { Selection } from 'shared/api/common/schemas/templates/selection'
import {
  Template,
  AdaptedTemplate,
  AdaptedCurrentVersion,
} from 'shared/api/common/schemas/templates/template'

export const templateAdapter = (item: Template): AdaptedTemplate => {
  const { current_version: mainCurrentVersion, description, ...rest } = item

  const { map, ...restMainCurrentVersion } = mainCurrentVersion
  const current_version: AdaptedCurrentVersion = { ...restMainCurrentVersion }

  if (mainCurrentVersion && mainCurrentVersion.map) {
    const map = contentMapAdapter(mainCurrentVersion.map)
    current_version.map = map
    current_version.selection = map.items.reduce(
      (res, item) => ((res[item.id] = true), res),
      {} as Selection,
    )
  }

  let flowsLockedStatus = undefined
  if (item?.flows_locked_status && !Array.isArray(item?.flows_locked_status)) {
    flowsLockedStatus = item.flows_locked_status
  }

  return {
    ...rest,
    id: item.template_id,
    isProtected: item.is_protected || false,
    isLocked: !item.is_editable || false,
    isTracked: item.is_tracked || false,
    description: description || {
      summary: '',
      guideLink: '',
      videoGuideLink: '',
    },
    flowsLockedStatus,
    current_version,
  }
}

export const installedTemplateAdapter = (
  template: InstalledTemplate,
): null | AdaptedInstalledTemplate => {
  if (template == null) {
    return template
  }

  const avatar = {
    url: template?.template_avatar?.avatar_url_100x100 ?? '',
    color: template?.template_avatar?.color ?? '',
  }

  // Fields Settings
  const idsMap = template?.details?.installation_settings?.template_fields_installation_map ?? {}
  const templateFields = (template.template_fields || []).reduce((prev, cur) => {
    const botFieldId = idsMap[cur.template_field_id]
    if (typeof botFieldId === 'number') {
      prev.push({ ...cur, field_id: botFieldId })
    }
    return prev
  }, [] as TemplateFieldAdapted[])

  const showWizard = templateFields.some((field) => field.wizard_enabled)

  const result: AdaptedInstalledTemplate = {
    installationId: template.installation_id,
    templateId: template.template_id,
    templateUrl: template.template_url,
    details: template.details,
    versionId: template.version_id,
    title: template.title,
    description: template.description || {
      summary: '',
      guideLink: '',
      videoGuideLink: '',
    },
    author: template.author_name,
    id: template.installation_id,
    avatar,
    authorUserdId: template.template_author_user_id,
    template_installation_access_data: template.template_installation_access_data,
    templateFields,
    showWizard,
  }

  if (template.map) {
    const map = contentMapAdapter(template.map)
    result.selection = map.items.reduce(
      (res, item) => ((res[item.id] = true), res),
      {} as Selection,
    )
    result.map = map
  }

  return result
}
